import React from 'react'
import s from './index.module.scss'

interface IData {
	title: string
	value: string | number | React.ReactNode
}

interface IProps {
	data: IData[]
	isColumn?: boolean
}

const SimpleTable: React.FC<IProps> = ({ data, isColumn }) => {
	return (
		<div
			className={s.wrapper}
			// style={{
			//   ...(!isColumn && {
			//     gridAutoFlow: 'column',
			//     gridTemplateRows: `repeat(${Math.ceil(data.length / 2)}, auto)`
			//   })
			// }}
		>
			{data.map((i: any) => (
				<div key={i.title} className={s.row}>
					<span className={s.rowTitle}>{i.title}</span>
					<span className={s.rowValue}>{i.value}</span>
				</div>
			))}
		</div>
	)
}

export default SimpleTable
